import { Effects as UserEffects } from '@app/store/user/user.effects';
import { Effects as InboxEffects } from '@app/store/inbox/inbox.effects';
import { Effects as AuthEffects } from '@app/store/auth/auth.effects';
import { Effects as TasksEffects } from '@app/modules/features/modules/tasks/store/tasks.effects';
import { Effects as PubNubEffects } from '@app/store/pubnub/pubnub.effects';

export const effects = [
  UserEffects,
  InboxEffects,
  AuthEffects,
  TasksEffects,
  PubNubEffects,
];
